import {ROUTE_NAMES} from "../../core/consts";
import {BaseConfig} from "../../infrastructure/config/base-config";
import {BettingRouteMetaDataModel} from "./models/betting-route.meta-data.model";

export class BettingContainerConfig extends BaseConfig {
  constructor(route: BettingRouteMetaDataModel) {
    super(ROUTE_NAMES.betting, route);
  }
}